import React from 'react';

interface AdminUserDetailSectionProps {
  sectionId: string;
  title: string;
  expanded: boolean;
  onToggle: () => void;
  rightContent?: React.ReactNode;
  headerButton?: React.ReactNode;
  children: React.ReactNode;
}

const AdminUserDetailSection: React.FC<AdminUserDetailSectionProps> = ({
  sectionId,
  title,
  expanded,
  onToggle,
  rightContent,
  headerButton,
  children,
}) => {
  return (
    <div className="bg-gradient-to-br from-slate-800/40 to-slate-900/60 backdrop-blur-xl rounded-lg shadow-xl border border-slate-700/40 mb-3">
      <div
        className="flex items-center justify-between px-4 py-2.5 cursor-pointer hover:bg-white/5 transition-colors"
        onClick={onToggle}
      >
        <div className="flex items-center gap-2">
          <svg
            className={`w-3.5 h-3.5 text-gray-400 transition-transform duration-200 ${expanded ? 'rotate-90' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          <h2 className="text-base font-semibold text-white">{title}</h2>
        </div>
        {rightContent}
        {!headerButton && expanded ? null : headerButton}
      </div>
      {expanded && <div className="px-4 pb-4">{children}</div>}
    </div>
  );
};

export default AdminUserDetailSection;
